const healthTargets = {
  state: {
    activitie: [
      {
        itemCode: '1',
        itemName: '进餐：使用餐具将饭菜送入口、咀嚼、吞咽等活动',
        score: null,
        anwserName: '',
        anwserItem: {
          可自理: { value: 0, name: '独立完成' },
          中度依赖: { value: 3, name: '需要协助，如切碎、搅拌食物等' },
          不能自理: { value: 5, name: '完全需要帮助' }
        }
      },
      {
        itemCode: '2',
        itemName: '梳洗：梳头、洗脸、刷牙、剃须、洗澡等活动',
        score: null,
        anwserName: '',
        anwserItem: {
          可自理: { value: 0, name: '独立完成' },
          轻度依赖: { value: 1, name: '能独立地洗头、梳头、洗脸、刷牙、剃须等，洗澡需要协助' },
          中度依赖: { value: 3, name: '在协助下和适当的时间内，能完成部分梳洗活动' },
          不能自理: { value: 7, name: '完全需要帮助' }
        }
      },
      {
        itemCode: '3',
        itemName: '穿衣：穿衣裤、袜子、鞋子等活动',
        score: null,
        anwserName: '',
        anwserItem: {
          可自理: { value: 0, name: '独立完成' },
          中度依赖: { value: 3, name: '需要协助，在适当的时间内完成部分穿衣' },
          不能自理: { value: 5, name: '完全需要帮助' }
        }
      },
      {
        itemCode: '4',
        itemName: '如厕：小便、大便等活动及自控',
        score: null,
        anwserName: '',
        anwserItem: {
          可自理: { value: 0, name: '不需协助，可自控' },
          轻度依赖: { value: 1, name: '偶尔失禁，但基本上能如厕或使用便具' },
          中度依赖: { value: 5, name: '经常失禁，在很多提示和协助下尚能如厕或使用便具' },
          不能自理: { value: 10, name: '完全失禁，完全需要帮助' }
        }
      },
      {
        itemCode: '5',
        itemName: '活动：站立、室内行走、上下楼梯、户外活动',
        score: null,
        anwserName: '',
        anwserItem: {
          可自理: { value: 0, name: '独立完成所有活动' },
          轻度依赖: { value: 1, name: '借助较小的外力或辅助装置能完成站立、行走、上下楼梯等' },
          中度依赖: { value: 5, name: '借助较大的外力才能完成站立、行走，不能上下楼梯' },
          不能自理: { value: 10, name: '卧床不起，活动完全需要帮助' }
        }
      }
    ],
    medicineGs: [
      {
        itemCode: '1',
        itemName: '(1)您精力充沛吗？(指精神头足，乐于做事)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 9
      },
      {
        itemCode: '2',
        itemName: '(2)您容易疲乏吗？(指体力如何，是否稍微活动一下或做一点家务劳动就感到累)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 1,
        tz2: 9

      },
      {
        itemCode: '3',
        itemName: '(3)您容易气短，呼吸短促，接不上气吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 1
      },
      {
        itemCode: '4',
        itemName: '(4)您说话声音低弱无力吗?(指说话没有力气)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 1,
        tz2: 9
      },
      {
        itemCode: '5',
        itemName: '(5)您感到闷闷不乐、情绪低沉吗?(指心情不愉快，情绪低落)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 7,
        tz2: 9
      },
      {
        itemCode: '6',
        itemName: '(6)您容易精神紧张、焦虑不安吗?(指遇事是否心情紧张)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 7
      },
      {
        itemCode: '7',
        itemName: '(7)您因为生活状态改变而感到孤独、失落吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 7
      },
      {
        itemCode: '8',
        itemName: '(8)您容易感到害怕或受到惊吓吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 7
      },
      {
        itemCode: '9',
        itemName: '(9)您感到身体超重不轻松吗?(感觉身体沉重)[BMI指数=体重(kg)/身高2(m)]',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '(BMI＜24)' },
          '很少(有一点/偶尔)': { value: 2, name: '(24≤BMI＜25)' },
          '有时(有些/少数时间)': { value: 3, name: '(25≤BMI＜26)' },
          '经常(相当/多数时间)': { value: 4, name: '(26≤BMI＜28)' },
          '总是(非常/每天)': { value: 5, name: '(BMI≥28)' }
        },
        tz: 4
      },
      {
        itemCode: '10',
        itemName: '(10)您眼睛干涩吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 3
      },
      {
        itemCode: '11',
        itemName: '(11)您手脚发凉吗?(不包含因周围温度低或穿的少导致的手脚发冷)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 2
      },
      {
        itemCode: '12',
        itemName: '(12)您胃脘部、背部或腰膝部怕冷吗？(指上腹部、背部、腰部或膝关节等，有一处或多处怕冷)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 2
      },
      {
        itemCode: '13',
        itemName: '(13)您比一般人耐受不了寒冷吗？(指比别人容易害怕冬天或是夏天的冷空调、电扇等)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 2,
        tz2: 9
      },
      {
        itemCode: '14',
        itemName: '(14)您容易患感冒吗?(指每年感冒的次数)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '一年＜2次' },
          '很少(有一点/偶尔)': { value: 2, name: '一年感冒2-4次' },
          '有时(有些/少数时间)': { value: 3, name: '一年感冒5-6次' },
          '经常(相当/多数时间)': { value: 4, name: '一年8次以上' },
          '总是(非常/每天)': { value: 5, name: '几乎每月都感冒' }
        },
        tz: 1
      },
      {
        itemCode: '15',
        itemName: '(15)您没有感冒时也会鼻塞、流鼻涕吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 8
      },
      {
        itemCode: '16',
        itemName: '(16)您有口粘口腻，或睡眠打鼾吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 4
      },
      {
        itemCode: '17',
        itemName: '(17)您容易过敏(对药物、食物、气味、花粉或在季节交替、气候变化时)吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '从来没有' },
          '很少(有一点/偶尔)': { value: 2, name: '一年1、2次' },
          '有时(有些/少数时间)': { value: 3, name: '一年3、4次' },
          '经常(相当/多数时间)': { value: 4, name: '一年5、6次' },
          '总是(非常/每天)': { value: 5, name: '每次遇到上述原因都过敏' }
        },
        tz: 8
      },
      {
        itemCode: '18',
        itemName: '(18)您的皮肤容易起荨麻疹吗? (包括风团、风疹块、风疙瘩)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 8
      },
      {
        itemCode: '19',
        itemName: '(19)您的皮肤在不知不觉中会出现青紫瘀斑、皮下出血吗?(指皮肤在没有外伤的情况下出现青一块紫一块的情况)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 6
      },
      {
        itemCode: '20',
        itemName: '(20)您的皮肤一抓就红，并出现抓痕吗?(指被指甲或钝物划过后皮肤的反应)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 8
      },
      {
        itemCode: '21',
        itemName: '(21)您皮肤或口唇干吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 3
      },
      {
        itemCode: '22',
        itemName: '(22)您有肢体麻木或固定部位疼痛的感觉吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 6
      },
      {
        itemCode: '23',
        itemName: '(23)您面部或鼻部有油腻感或者油亮发光吗?(指脸上或鼻子)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 5
      },
      {
        itemCode: '24',
        itemName: '(24)您面色或目眶晦黯，或出现褐色斑块/斑点吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 6
      },
      {
        itemCode: '25',
        itemName: '(25)您有皮肤湿疹、疮疖吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 5
      },
      {
        itemCode: '26',
        itemName: '(26)您感到口干咽燥、总想喝水吗？',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 3
      },
      {
        itemCode: '27',
        itemName: '(27)您感到口苦或嘴里有异味吗?(指口苦或口臭)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 5
      },
      {
        itemCode: '28',
        itemName: '(28)您腹部肥大吗?(指腹部脂肪肥厚)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '(腹围<80cm，相当于2.4尺)' },
          '很少(有一点/偶尔)': { value: 2, name: '(腹围80-85cm，2.4-2.55尺)' },
          '有时(有些/少数时间)': { value: 3, name: '(腹围86-90cm，2.56-2.7尺)' },
          '经常(相当/多数时间)': { value: 4, name: '(腹围91-105cm，2.71-3.15尺)' },
          '总是(非常/每天)': { value: 5, name: '(腹围>105cm或3.15尺)' }
        },
        tz: 4
      },
      {
        itemCode: '29',
        itemName: '(29)您吃(喝)凉的东西会感到不舒服或者怕吃(喝)凉的东西吗？(指不喜欢吃凉的食物，或吃了凉的食物后会不舒服)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 2
      },
      {
        itemCode: '30',
        itemName: '(30)您有大便黏滞不爽、解不尽的感觉吗?(大便容易粘在马桶或便坑壁上)',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 5
      },
      {
        itemCode: '31',
        itemName: '(31)您容易大便干燥吗?',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 3
      },
      {
        itemCode: '32',
        itemName: '(32)您舌苔厚腻或有舌苔厚厚的感觉吗?（如果自我感觉不清楚可由调查员观察后填写）',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 4
      },
      {
        itemCode: '33',
        itemName: '(33)您舌下静脉瘀紫或增粗吗？（可由调查员辅助观察后填写）',
        score: null,
        anwserName: '',
        anwserItem: {
          '没有(根本不/从来没有)': { value: 1, name: '没有(根本不/从来没有)' },
          '很少(有一点/偶尔)': { value: 2, name: '很少(有一点/偶尔)' },
          '有时(有些/少数时间)': { value: 3, name: '有时(有些/少数时间)' },
          '经常(相当/多数时间)': { value: 4, name: '经常(相当/多数时间)' },
          '总是(非常/每天)': { value: 5, name: '总是(非常/每天)' }
        },
        tz: 6
      }
    ],
    medicineGuides: [
      {
        itemCode: '1',
        itemName: '气虚质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '2',
        itemName: '阳虚质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '3',
        itemName: '阴虚质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '4',
        itemName: '痰湿质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '5',
        itemName: '湿热质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '6',
        itemName: '血瘀质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '7',
        itemName: '气郁质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '8',
        itemName: '特禀质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      },
      {
        itemCode: '9',
        itemName: '平和质',
        contentType: '1',
        content: {
          评分: null,
          体质辨识: '',
          中医药保健指导: { value: [], other: '' }
        }
      }
    ],
    heathinfos: {
      症状: [],
      症状其它: '',
      一般状况: {
        体温: '',
        脉率: '',
        呼吸频率: '',
        左侧血压: { value1: '', value2: '' },
        右侧血压: { value1: '', value2: '' },
        身高: '',
        体重: '',
        腰围: '',
        体质指数: '',
        老年人健康状态自我评估: '',
        老年人生活自理能力自我评估: '',
        老年人认知功能: { value: '', zf: '' },
        老年人情感状态: { value: '', zf: '' }
      },
      生活方式: {
        锻炼频率: '',
        每次锻炼时间: '',
        坚持锻炼时间: '',
        锻炼方式: { value: [], qt: '' },
        饮食习惯: [],
        吸烟状况: '',
        平均日吸烟量: '',
        开始吸烟年龄: '',
        戒烟年龄: '',
        饮酒频率: '',
        平均日饮酒量: '',
        是否戒酒: '',
        戒酒年龄: '',
        开始饮酒年龄: '',
        近一年是否醉酒: '',
        饮酒种类: [],
        职业病危险因素接触史: {
          value: '',
          工种: '',
          从业时间: '',
          粉尘: { value: '', 防护措施: { value: '', content: '' }},
          放射物质: { value: '', 防护措施: { value: '', content: '' }},
          物理因素: { value: '', 防护措施: { value: '', content: '' }},
          化学物质: { value: '', 防护措施: { value: '', content: '' }},
          其它: { value: '', 防护措施: { value: '', content: '' }}
        }
      },
      脏器功能: {
        口唇: '',
        齿列: { value: [], 缺齿: ['', '', '', ''], 龋齿: ['', '', '', ''], 义齿: ['', '', '', ''] },
        咽部: '',
        左眼: '',
        右眼: '',
        矫正视力: { value1: '', value2: '' },
        听力: '',
        运动功能: '',
        视力情况补充: ''
      },
      查体: {
        眼底: { value: '', content: '' },
        皮肤: { value: '', content: '' },
        巩膜: { value: '', content: '' },
        淋巴结: { value: '', content: '' },
        桶状肺: '',
        呼吸音: { value: '', content: '' },
        罗音: { value: '', content: '' },
        心率: '',
        心律: '',
        杂音: { value: '', content: '' },
        压痛: { value: '', content: '' },
        包块: { value: '', content: '' },
        肝大: { value: '', content: '' },
        脾大: { value: '', content: '' },
        移动性浊音: { value: '', content: '' },
        下肢水肿: '',
        足背动脉搏动: '',
        肛门指诊: { value: '', content: '' },
        乳腺: { value: [], content: '' },
        外阴: { value: '', content: '' },
        阴道: { value: '', content: '' },
        宫颈: { value: '', content: '' },
        宫体: { value: '', content: '' },
        附件: { value: '', content: '' },
        其它: ''
      },
      辅助检查: {
        血红蛋白: '',
        白细胞: '',
        血小板: '',
        血常规其它: '',
        尿蛋白: '',
        尿糖: '',
        尿酮体: '',
        尿潜血: '',
        尿常规其它: '',
        空腹血糖: { value1: '', value2: '' },
        尿微量白蛋白: '',
        大便潜血: '',
        糖化血红蛋白: '',
        乙型肝炎表面抗原: '',
        血清谷丙转氨酶: '',
        血清谷草转氨酶: '',
        白蛋白: '',
        总胆红素: '',
        结合胆红素: '',
        血清肌酐: '',
        血尿素氮: '',
        血钾浓度: '',
        血钠浓度: '',
        总胆固醇: '',
        甘油三酯: '',
        血清低密度脂蛋白胆固醇: '',
        血清高密度脂蛋白胆固醇: '',
        心电图: { value: '', content: '', img: [] },
        胸部X线片: { value: '', content: '' },
        B超: { value: '', content: '', img: [] },
        宫颈涂片: { value: '', content: '' },
        其他: '',
        Sp02: '',
        肺通气功能: { value: '', FEV1: '', FVC: '', FEV1FVC: '', 占预计值百分比FEV1: '' }
      },
      现存主要健康问题: {
        脑血管疾病: { value: [], content: '' },
        呼吸系统疾病: { value: [], content: '' },
        肾脏疾病: { value: [], content: '' },
        心脏疾病: { value: [], content: '' },
        血管疾病: { value: [], content: '' },
        眼部疾病: { value: [], content: '' },
        神经系统疾病: { value: '', content: '' },
        其它系统疾病: { value: '', content: '' }
      },
      其它: {
        住院史: {
          value: '', content: [
            { 入出院日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 入出院日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 入出院日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 入出院日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' }
          ]
        },
        家庭病床史: {
          value: '', content: [
            { 建撤床日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 建撤床日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 建撤床日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' },
            { 建撤床日期: ['', ''], 原因: '', 医疗机构名称: '', 病案号: '' }
          ]
        },
        主要用药情况: {
          value: '', content: [
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' },
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' },
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' },
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' },
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' },
            { 药物名称: '', 用法: '', 用量: '', 用药时间: '', 服药依从性: '' }
          ]
        },
        非免疫规划预防接种: {
          value: '', content: [
            { 名称: '', 接种日期: '', 接种机构: '', 用药时间: '', 服药依从性: '' },
            { 名称: '', 接种日期: '', 接种机构: '', 用药时间: '', 服药依从性: '' },
            { 名称: '', 接种日期: '', 接种机构: '', 用药时间: '', 服药依从性: '' },
            { 名称: '', 接种日期: '', 接种机构: '', 用药时间: '', 服药依从性: '' }
          ]
        },
        健康评价: {
          value: '', content: ['', '', '', '']
        },
        健康指导: [],
        危险因素控制: { value: [], tz: '', ym: '', qt: '', yw: '' },
        备注: ''
      }
    },
    // phthises: {
    //   临床症状: ['无'],
    //   密切接触史: {
    //     value: "无",
    //     content:[
    //       {
    //         姓名: '',
    //         性别: '',
    //         年龄: '',
    //         接触方式: [],
    //         接触累计时间:''
    //       }
    //     ]
    //   },
    //   病史与治疗史:{
    //     value: '无',
    //     content: [
    //       {
    //         发病年月: '',
    //         治疗时间: '',
    //         备注:''
    //       }
    //     ]
    //   }

    // }
    phthises: {
      临床症状: {
        value: ['无'],
        qt: ''
      },
      肺结核可疑症状者: '否',
      密切接触史: '无',
      结核病史: '无',
      结核病治疗史: '',
      其它病史: []
    }
  }
}

export default healthTargets
